// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"ProgressBar__dimmer--_buJF","progress":"ProgressBar__progress--3T4s0"};